import { cn } from '@/lib/cn';

type Props = {
  /** Tailwind height utility for the centred wrapper. Defaults to `h-60` to
   *  match the dominant variant in the codebase; pass `h-40` (or any other)
   *  for compact contexts like nested cards. */
  containerClassName?: string;
};

/**
 * Standard loading spinner used across list/detail pages and the route-level
 * Suspense fallback (App.tsx). Renders a 32px ring, themed via the
 * `--tg-accent` CSS variable so it matches the active Telegram theme color,
 * centred in a vertically-sized box so callers don't need to repeat the
 * flex/center boilerplate.
 */
export function Spinner({ containerClassName = 'flex-1 min-h-[16rem]' }: Props = {}) {
  return (
    <div className={cn('flex items-center justify-center', containerClassName)}>
      <div
        className="h-8 w-8 animate-spin rounded-full border-2 border-app/20"
        style={{ borderTopColor: 'var(--tg-accent, currentColor)' }}
      />
    </div>
  );
}
